var map = {
	"./audio/music-pause.png": 4837,
	"./audio/music-play.png": 8965,
	"./choose/choose_bg.jpg": 4541,
	"./choose/hand.png": 6839,
	"./choose/select/choose_select01.png": 5190,
	"./choose/select/choose_select02.png": 6397,
	"./choose/select/choose_select03.png": 9716,
	"./choose/select/choose_select04.png": 9627,
	"./choose/select/choose_select05.png": 8498,
	"./choose/select/choose_select06.png": 8233,
	"./choose/select/choose_select07.png": 1984,
	"./choose/select/choose_select08.png": 1895,
	"./choose/select/choose_select09.png": 2670,
	"./choose/select/choose_select10.png": 8132,
	"./choose/time.png": 8635,
	"./choose/unselect/choose_unselect01.png": 8574,
	"./choose/unselect/choose_unselect02.png": 997,
	"./choose/unselect/choose_unselect03.png": 3484,
	"./choose/unselect/choose_unselect04.png": 7091,
	"./choose/unselect/choose_unselect05.png": 6330,
	"./choose/unselect/choose_unselect06.png": 5313,
	"./choose/unselect/choose_unselect07.png": 2600,
	"./choose/unselect/choose_unselect08.png": 4255,
	"./choose/unselect/choose_unselect09.png": 5510,
	"./choose/unselect/choose_unselect10.png": 5228,
	"./detail/button_haibao.png": 373,
	"./detail/button_jixu.png": 6799,
	"./detail/button_ruhua.png": 2394,
	"./detail/detailalert/detailalert01.png": 4982,
	"./detail/detailalert/detailalert02.png": 8749,
	"./detail/detailalert/detailalert03.png": 1268,
	"./detail/detailalert/detailalert04.png": 3259,
	"./detail/detailalert/detailalert05.png": 9602,
	"./detail/detailalert/detailalert06.png": 3609,
	"./detail/detailalert/detailalert07.png": 7856,
	"./detail/detailalert/detailalert08.png": 1687,
	"./detail/detailalert/detailalert09.png": 8046,
	"./detail/detailalert/detailalert10.png": 7076,
	"./detail/detailtext/detail01.png": 4997,
	"./detail/detailtext/detail02.png": 4638,
	"./detail/detailtext/detail03.png": 215,
	"./detail/detailtext/detail04.png": 1224,
	"./detail/detailtext/detail05.png": 2353,
	"./detail/detailtext/detail06.png": 1770,
	"./detail/detailtext/detail07.png": 6979,
	"./detail/detailtext/detail08.png": 1684,
	"./detail/detailtext/detail09.png": 4717,
	"./detail/detailtext/detail10.png": 7255,
	"./enter.png": 2440,
	"./home_bg.jpg": 8531,
	"./home_title.png": 8006,
	"./logo.png": 3153,
	"./nav_bg.jpg": 6599,
	"./nav_title.png": 2034,
	"./poster_video.jpg": 2631,
	"./treasure/rightarrow.png": 3385,
	"./treasure/treasure01.png": 294,
	"./treasure/treasure02.png": 7709,
	"./treasure/treasure03.png": 6580,
	"./treasure/treasure04.png": 8571,
	"./treasure/treasure05.png": 4914,
	"./treasure/treasure06.png": 8921,
	"./treasure/treasure07.png": 3168,
	"./treasure/treasure_bg.jpg": 4517,
	"./video_poster.jpg": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6012;